import React, { useState } from 'react';
import { GET_DOCUMENTS_FROM_PC_getDocumentsFromPC_documentsList } from '../../pages/DocumentsInformationPage/graphql/__generated__/GET_DOCUMENTS_FROM_PC';
import { Box, Text } from 'grommet';
import {
  Select,
  SelectWrapper,
  StyledDocumentsBox,
  UploadButton
} from './DocumentsTableStyles';
import DocumentsList from './DocumentsList';
import pdfIcon from '../../assets/images/PDF Icon.svg';
import UploadModal from '../uploadModal';

type Document = GET_DOCUMENTS_FROM_PC_getDocumentsFromPC_documentsList;

export interface DocumentsTableProps {
  documents: Document[];
  accountNumber: string;
  policies: GET_POLICIES_BY_ACCOUNT_account_items_policies_items[] | [];
  downloadDocument: Function;
}

export function iconType(fileType: string) {
  let icon = <img src={pdfIcon} alt="PDF" />;
  if (fileType.includes('pdf')) {
    icon = <img src={pdfIcon} alt="PDF" />;
  }
  return icon;
}

enum DocumentType {
  All = 'All Documents',
  PDF = 'PDF',
  HTML = 'HTML',
  IdCard = 'ID Card',
  Declaration = 'Declaration Pages',
  NoticeDocument = 'Notice',
  Other = 'Other'
}

let documentTypeOptions = [
  DocumentType.All,
  DocumentType.PDF,
  DocumentType.HTML,
  DocumentType.IdCard,
  DocumentType.Declaration,
  DocumentType.NoticeDocument,
  DocumentType.Other
];

const hasFileType = (type: string) => (document: Document) =>
  document?.mimeType === type;
const isPDF = hasFileType('application/pdf');
const isHTML = hasFileType('text/html');
const hasFileName = (type: string) => (document: Document) =>
  document?.name?.includes(type);
const isIdCard = hasFileName('ID Card');
const isDeclaration = hasFileName('Declaration');
const isNoticeDocument = hasFileName('Notice');
const isOther = (document: Document) =>
  !(
    document.name?.includes('ID Card') ||
    document.name?.includes('Declaration') ||
    document.name?.includes('E-Pay Statement') ||
    document.name?.includes('Notice')
  );

const filterDocuments = (documents: Document[], filter: DocumentType) => {
  switch (filter) {
    case DocumentType.PDF:
      return documents.filter(isPDF);
    case DocumentType.HTML:
      return documents.filter(isHTML);
    case DocumentType.IdCard:
      return documents.filter(isIdCard);
    case DocumentType.Declaration:
      return documents.filter(isDeclaration);
    case DocumentType.NoticeDocument:
      return documents.filter(isNoticeDocument);
    case DocumentType.Other:
      return documents.filter(isOther);
    case DocumentType.All:
    default:
      return documents;
  }
};

export interface GET_POLICIES_BY_ACCOUNT_account_items_policies_items {
  __typename: 'Policy';
  policy_type: string | null;
  policy_number: string | null;
  expiration_date: any | null;
}

export default ({
  documents,
  accountNumber,
  policies,
  downloadDocument
}: DocumentsTableProps) => {
  const Documents = DocumentsList;
  const [selectedFilter, setSelectedFilter] = useState(DocumentType.All);
  const [showModal, setShowModal] = useState(false);
  const [staging, setStaging] = useState(false);
  return (
    <Box fill>
      {showModal && (
        <UploadModal
          staging={staging}
          showModalHandler={setShowModal}
          stagingHandler={setStaging}
          policies={policies}
          readOnlyAccess={false}
          readOnlyFeatureFlag={false}
        />
      )}
      {!documents || documents?.length === 0 || documents.every(doc => !doc) ? (
        <Text size="medium">No documents found for this account</Text>
      ) : (
        <Box responsive direction="column" gap="36px">
          <Box align="end" direction="row" justify="between">
            <UploadButton
              id="OpenModal"
              onClick={() => {
                setStaging(false);
                setShowModal(true);
              }}
            >
              UPLOAD DOCUMENTS
            </UploadButton>
            <SelectWrapper>
              <Select
                options={documentTypeOptions}
                value={selectedFilter}
                onChange={({ option }) => {
                  setSelectedFilter(option);
                }}
              />
            </SelectWrapper>
          </Box>
          <StyledDocumentsBox>
            <Documents
              accountNumber={accountNumber}
              policies={policies}
              documents={filterDocuments(
                documents,
                selectedFilter as DocumentType
              )}
              downloadDocument={downloadDocument}
            />
          </StyledDocumentsBox>
        </Box>
      )}
    </Box>
  );
};
